import { replaceVariableInText } from './replaceVariableInText';
import { EMPTY_OBJECT } from '../constants';

export const replaceVariablesInRichText = (
  text: string,
  replacements: Record<string, string> = EMPTY_OBJECT,
): string => {
  let serializedText = text;
  const replacementsEntries = Object.entries(replacements);

  if (text && replacementsEntries.length) {
    for (const [key, value] of replacementsEntries) {
      const pattern = `%${key}%`;

      if (text.includes(pattern)) {
        serializedText = replaceVariableInText(serializedText, key, value);
      }
    }
  }

  return serializedText;
};
